// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__s6NeK","largestCol":"styles_largestCol__3IFgy","smallestCol":"styles_smallestCol__1JFBK"};